import {
  PublishParams,
  StoreFields,
  StoreListParams,
} from "../../view/Modules/Stores/StoreDataTypes";
import AxiosInstance from "../config/axiosInterceptor";
import { statusArr } from "../config/AppConstants";
import { ContentApiRoutes } from "../../navigation/NavConstant";

export const StoreServices = {
  getStores: (params?: any) => {
    return AxiosInstance.get(ContentApiRoutes.STORES, { params });
  },
  exportStores: (params: StoreListParams) => {
    return AxiosInstance.get(ContentApiRoutes.EXPORT_STORES, {
      params,
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "stores-export.xls");
      document.body.appendChild(link);
      link.click();
    });
  },
  createStore: (data: StoreFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_STORE, data),
  updateStore: (id: number, data: StoreFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_STORE.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  publishStore: (id: number, data: PublishParams) =>
    AxiosInstance.put(
      ContentApiRoutes.PUBLISH_STORE.replace(":id", id.toString()),
      data
    ),

  publishBulkStore: (ids: number[], data: PublishParams) =>
    AxiosInstance.put(ContentApiRoutes.PUBLISH_BULK_STORE, {
      ...data,
      ...{ ids: ids.toString() },
    }),

  assignBulkStoreGroup: (ids: number[], data: any) =>
    AxiosInstance.put(ContentApiRoutes.ASSIGN_BULK_STORE_GROUP, {
      ...data,
      ...{ ids: ids.toString() },
    }),

  deleteStore: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_STORE.replace(":id", id.toString())
    ),

  deleteBulkStore: (ids: number[]) => {
    let idl = { ids: ids.toString() };
    return AxiosInstance.put(ContentApiRoutes.DELETE_BULK_STORE, idl);
  },
  getRegions: (params?: any) => {
    return AxiosInstance.get(ContentApiRoutes.REGIONS, { params });
  },
  getStoreGroups: (params?: any) => {
    return AxiosInstance.get(ContentApiRoutes.STORE_GROUPS, { params });
  },

  viewStore: (id: number) => {
    return AxiosInstance.get(
      ContentApiRoutes.VIEW_STORE.replace(":id", id.toString())
    );
  },
};
